import { LockSimple } from '@phosphor-icons/react';
import { t } from 'i18next';

import { Tooltip } from 'core/elements';
import { renderHtmlMessage } from 'core/utils';
import { QuotePartHelper } from 'quotes/helpers';
import { ICustomerQuotePart } from 'quotes/types';
import { theme } from 'theme';
import { Color, TooltipPosition } from 'theme/enums';

export const PriceLockTooltip = ({
  quotePart,
  priceLocked = false,
  placement = TooltipPosition.TOP,
  tooltipTitle = t('labelExternalPriceLocked'),
}: {
  quotePart?: ICustomerQuotePart;
  priceLocked?: boolean;
  placement?: TooltipPosition;
  tooltipTitle?: string;
}) => {
  const isPriceLocked = priceLocked || QuotePartHelper.isPriceLocked(quotePart);

  if (!isPriceLocked) {
    return <></>;
  }

  return (
    <Tooltip title={renderHtmlMessage(tooltipTitle)} color={Color.DANGER} placement={placement}>
      <LockSimple
        weight="fill"
        style={{ color: `rgba(${theme.palette?.danger.mainChannel} / 1)` }}
      />
    </Tooltip>
  );
};
